import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MenuService} from '../menu.service';
import {ConnectionPositionPair, CdkConnectedOverlay, Overlay} from '@angular/cdk/overlay';
import {MenuItemLocal} from '../menu-item.model';
import {first} from 'rxjs/operators';
import {customIcons} from '../menu.component';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-menu-container',
    templateUrl: './menu-container.component.html',
    styleUrls: ['./menu-container.component.scss'],
    standalone: false
})
export class MenuContainerComponent implements OnInit {
  @Input() menu: MenuItemLocal;
  @Input() isMenuCollapsed: boolean;
  @Input() isDesktop: boolean;
  @Input() isConfigMode: boolean;

  @Output() favoriteMenuSelected = new EventEmitter();

  // @ts-ignore
  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay: CdkConnectedOverlay;

  public connectionPositionPairs: ConnectionPositionPair[] = [
    new ConnectionPositionPair({originX: 'end', originY: 'top'}, {overlayX: 'start', overlayY: 'top'}, 0, 3, 'cdk-overlay-pane_top'),
    new ConnectionPositionPair({originX: 'end', originY: 'center'}, {overlayX: 'start', overlayY: 'center'}, 0, 0, 'cdk-overlay-pane_center'),
    new ConnectionPositionPair({originX: 'end', originY: 'bottom'}, {overlayX: 'start', overlayY: 'bottom'}, 0, 0, 'cdk-overlay-pane_bottom')
  ];

  constructor(private element: ElementRef, private menuService: MenuService, private overlay: Overlay, private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    return;
  }

  /*
    public isActiveChild(subMenuArray: MenuItem[]) {
      return subMenuArray
        .some(menuItem => window.location.hash.startsWith(this.urlPrefix + '/' + menuItem.pathArray.join('/')));
    }
  */

  public toggleMenuState(menu: MenuItemLocal) {
    menu.state = !menu.state;
    if (menu.pathArray) {
      const location = this.menuService.isActiveLink(menu.pathArray.join('/'));
    }


    // Every time submenu open check top of overlay is not outside viewport. If so set it to 0.
    this.cdkConnectedOverlay?.positionChange.pipe(first()).subscribe(posChange => {
      // change any properties that you need about the connectedOverlay
      this.cdkConnectedOverlay.offsetY = 0;
      // this will trigger again positionChange thats why we only take the first
      this.cdkConnectedOverlay.overlayRef.updatePosition();

      if (this.cdkConnectedOverlay.overlayRef.overlayElement.offsetTop < 0) {
        this.cdkConnectedOverlay.overlayRef.overlayElement.style.top = '0';
      }
    });
  }

  public clickedOutsideOverlay(event, menu) {
    if (!this.element.nativeElement.contains(event.target)) {
      menu.state = false;
    }

  }

  private isMdIcon(icon: string) {
    if (!icon) { return false; }
    return icon.startsWith('md');
  }

  private getMdIcon(icon: string) {
    if (!icon) { return 'cloud'; }
    return icon.substr(2);
  }

  private isFaIcon(icon: string) {
    if (!icon) { return false; }
    return icon.startsWith('fa');
  }

  private isSvgIcon(icon: string) {
    if (!icon) { return false; }
    return icon.startsWith('svg');
  }

  private getSvgIcon2(icon: string) {
    if (icon.startsWith('svg')) {
      const name = icon.substr(4);
      return name.trim().toLowerCase();
    }
    return '';
  }

  private getSvgIcon(icon: string) {
    if (icon.startsWith('svg')) {
      const name = icon.substr(4);
      const data = customIcons.filter(_icon => _icon.iconName === name);
      if (data && data.length === 1) {
        const url = data[0].iconData;
        return this.sanitizer.bypassSecurityTrustHtml(url);
      }
    }

    return '';
  }

}
